export enum TipoCertificadoGenerado {
  GENERADO_SISTEMA = 'GENERADO_SISTEMA',
  EXTERNO = 'EXTERNO',
  PROFESOR = 'PROFESOR',
}

export interface ICertificate {
  id: string;
  tipo: string;
  fechaCreacion: string;
  adjunto: string;
  tieneLinkExterno: boolean;
  linkExterno: string | null;
  datosCertificado: {
    tipoCertificado: string;
    frase: string;
    fechaCertificado: string;
    tipoGeneracion: TipoCertificadoGenerado;
    cantidadCaracteres: number;
    fraseInicial: string;
    temas: string | null;
    idioma: 'es' | 'de';
  };
  usuario: {
    nombre: string;
    primerApellido: string;
    segundoApellido: string;
  };
}

export interface ICertificateEdit {
  tipoGenerado: TipoCertificadoGenerado;
  id: string;
  tipoCertificado: string | null;
  frase: string | null;
  fechaCertificado: string | Date | null;
  nombreCompleto: string;

  fraseInicial: string | null;
  cantidadCaracteres: number | null;
  temas: string | null;
  cantidadCaracteresTematicas?: number | null;

  // SI ES EXTERNO
  urlArchivo: string | null;
  adjunto: string | null;

  idioma: 'es' | 'de';
}

export interface ICertificateForm {
  tipoCertificado: string;
  archivo: FileList | File[] | null;
  frase: string;
  fechaCertificado: string;
  temas?: string
  tipoCertificadoGenerar: 'PROFESORES' | 'ESTUDIANTES'
}

export interface ICertificateUploadForm {
  id: string | null;
  esProfesor: boolean;
  usuario: string | null;
  urlArchivo: string | null;
  adjunto: string | null;
}

export interface ICertificateGenerate {
  idUsuario: string;
  idPlantilla: string;
  frase: string;
  fecha: string;
  idioma?: 'es' | 'de';
  genero?: string;
  temas?: string;
}

export interface IUSuariosVerificadosCertificado {
  idUsuario: string;
  nombreCompleto: string;
  fecha: string;
  genero?: string;
  idTipoCertificado?: string
  tipoCertificado: string
}
